class StageTokenUpdates {

  /**
   * Constructor of stage token updates
   */
  constructor() {
    this.tokenFields = document.querySelectorAll('[name="stage_token"]');
    if(this.tokenFields.length > 0) {
      this._getStageToken();
    }
  }

  /**
   * Get new token from stage-ajax
   *
   * @returns {undefined}
   */
  _getStageToken() {
    fetch('/stage-ajax/getNewStageToken')
      .then(response => response.json())
      .then((response) => {
        this.tokenFields.forEach( tokenField => {
          tokenField.value = response.token;
        })
      });

  }
}

export default StageTokenUpdates;
